import { FormlyFieldConfig } from '@ngx-formly/core';

import { ISnToggleTooltipTemplateOptions } from './toggle-tooltip-template-options.interface';

export interface ISnToggleTooltipFormFieldConfig extends FormlyFieldConfig {
  type: 'toggle-tooltip';
  defaultValue?: boolean;
  templateOptions: ISnToggleTooltipTemplateOptions;
}
